/**
 * @author Fernando Ruano
 * @file index.js
 * @description CardI tem Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './styles.module.css';

/**
 * Card Item Component.
 * @return { Node } React Card Item Component
 */
const CardItem = ({ children, className }) => {
  return (
    <div className={[styles.contentBoard, className].join(' ')}>{children}</div>
  );
};

/**
 * @name CardItem.propTypes
 * @type { Object }
 */
CardItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

/**
 * Default props
 */
CardItem.defaultProps = {};

export default CardItem;
